export enum NodeType {
    ArrayExpression = 'ArrayExpression',
    ArrayPattern = 'ArrayPattern',
    ArrowFunctionExpression = 'ArrowFunctionExpression',
    AssignmentExpression = 'AssignmentExpression',
    AssignmentPattern = 'AssignmentPattern',
    AwaitExpression = 'AwaitExpression',
    BinaryExpression = 'BinaryExpression',
    BlockStatement = 'BlockStatement',
    BreakStatement = 'BreakStatement',
    CallExpression = 'CallExpression',
    CatchClause = 'CatchClause',
    ClassDeclaration = 'ClassDeclaration',
    ContinueStatement = 'ContinueStatement',
    ExportNamedDeclaration = 'ExportNamedDeclaration',
    ExpressionStatement = 'ExpressionStatement',
    FunctionDeclaration = 'FunctionDeclaration',
    FunctionExpression = 'FunctionExpression',
    Identifier = 'Identifier',
    IfStatement = 'IfStatement',
    ImportDeclaration = 'ImportDeclaration',
    ImportDefaultSpecifier = 'ImportDefaultSpecifier',
    ImportNamespaceSpecifier = 'ImportNamespaceSpecifier',
    ImportSpecifier = 'ImportSpecifier',
    LabeledStatement = 'LabeledStatement',
    Literal = 'Literal',
    LogicalExpression = 'LogicalExpression',
    MemberExpression = 'MemberExpression',
    MethodDefinition = 'MethodDefinition',
    ObjectExpression = 'ObjectExpression',
    ObjectPattern = 'ObjectPattern',
    Program = 'Program',
    Property = 'Property',
    RestElement = 'RestElement',
    ReturnStatement = 'ReturnStatement',
    Super = 'Super',
    SwitchCase = 'SwitchCase',
    SwitchStatement = 'SwitchStatement',
    TaggedTemplateExpression = 'TaggedTemplateExpression',
    TemplateLiteral = 'TemplateLiteral',
    TryStatement = 'TryStatement',
    UnaryExpression = 'UnaryExpression',
    UpdateExpression = 'UpdateExpression',
    VariableDeclaration = 'VariableDeclaration',
    VariableDeclarator = 'VariableDeclarator',
    WhileStatement = 'WhileStatement'
}
